export default __webpack_public_path__ + "static/media/graphic-10.914247c6.png";